import React, { useState, useEffect } from 'react';
import MultiplayerKBC from './Games/QuizGame/MultiplayerKBC';
import './Games/QuizGame/QuizGame.css';

const EmbeddedGame = () => {
  const [gameSession, setGameSession] = useState(null);
  const [userName, setUserName] = useState('');
  const [userClass, setUserClass] = useState('');
  const [gameStarted, setGameStarted] = useState(false);
  const [questions, setQuestions] = useState([]);

  // Sample questions for demo
  const sampleQuestions = [
    {
      question: "What is the capital of India?",
      options: ["Mumbai", "Delhi", "Kolkata", "Chennai"],
      correctAnswer: "Delhi",
      hint: "It's the political center of India"
    },
    {
      question: "What is 15 + 25?",
      options: ["30", "35", "40", "45"],
      correctAnswer: "40",
      hint: "Add the numbers carefully"
    },
    {
      question: "Which planet is known as the Red Planet?",
      options: ["Venus", "Mars", "Jupiter", "Saturn"],
      correctAnswer: "Mars",
      hint: "It appears red due to iron oxide"
    },
    {
      question: "What is the largest mammal?",
      options: ["Elephant", "Blue Whale", "Giraffe", "Hippopotamus"],
      correctAnswer: "Blue Whale",
      hint: "It lives in the ocean"
    },
    {
      question: "How many sides does a triangle have?",
      options: ["2", "3", "4", "5"],
      correctAnswer: "3",
      hint: "Think about the shape's name"
    },
    {
      question: "What is the chemical symbol for water?",
      options: ["H2O", "CO2", "NaCl", "O2"],
      correctAnswer: "H2O",
      hint: "Two hydrogen atoms and one oxygen atom"
    },
    {
      question: "Which is the smallest prime number?",
      options: ["0", "1", "2", "3"],
      correctAnswer: "2",
      hint: "It's the only even prime number"
    },
    {
      question: "What do plants need to make food?",
      options: ["Sunlight", "Water", "Carbon dioxide", "All of the above"],
      correctAnswer: "All of the above",
      hint: "Photosynthesis requires multiple things"
    },
    {
      question: "How many continents are there?",
      options: ["5", "6", "7", "8"],
      correctAnswer: "7",
      hint: "Asia, Africa, North America, South America, Antarctica, Europe, Australia"
    },
    {
      question: "What is 12 × 8?",
      options: ["84", "96", "104", "112"],
      correctAnswer: "96",
      hint: "Multiply carefully"
    },
    {
      question: "Which gas do we breathe in?",
      options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Hydrogen"],
      correctAnswer: "Oxygen",
      hint: "Essential for life"
    },
    {
      question: "What is the past tense of 'go'?",
      options: ["Gone", "Going", "Went", "Goes"],
      correctAnswer: "Went",
      hint: "Yesterday I ___ to school"
    }
  ];

  const startGame = () => {
    if (!userName.trim()) {
      alert('Please enter your name');
      return;
    }

    const session = {
      id: `embedded-game-${Date.now()}`,
      players: [{ name: userName, class: userClass }],
      questions: sampleQuestions,
      type: 'embedded-kbc'
    };

    setGameSession(session);
    setGameStarted(true);
  };

  const exitGame = () => {
    setGameSession(null);
    setGameStarted(false);
    setUserName('');
    setUserClass('');
  };

  if (!gameStarted) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{
          background: 'white',
          padding: '40px',
          borderRadius: '15px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
          textAlign: 'center',
          maxWidth: '400px',
          width: '90%'
        }}>
          <h1 style={{ color: '#333', marginBottom: '30px' }}>🎯 KBC Quiz Game</h1>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="text"
              placeholder="Enter your name"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '16px',
                marginBottom: '15px'
              }}
            />
            <input
              type="text"
              placeholder="Enter your class (optional)"
              value={userClass}
              onChange={(e) => setUserClass(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontSize: '16px'
              }}
            />
          </div>
          <button
            onClick={startGame}
            style={{
              background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
              color: 'white',
              border: 'none',
              padding: '15px 30px',
              borderRadius: '8px',
              fontSize: '18px',
              fontWeight: 'bold',
              cursor: 'pointer',
              width: '100%',
              transition: 'transform 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
          >
            🚀 Start Game
          </button>
          <p style={{ marginTop: '20px', color: '#666', fontSize: '14px' }}>
            Answer 12 questions and test your knowledge!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#000' }}>
      <MultiplayerKBC
        gameSession={gameSession}
        userRole="student"
        userName={userName}
        userClass={userClass || 'Guest'}
        onExit={exitGame}
      />
    </div>
  );
};

export default EmbeddedGame;